<h2>Multi-Factor Authentication</h2>
<mat-card *ngIf="currentUser && !disabling" [ngSwitch]="currentUser.mfaType">
  <ng-container *ngSwitchCase="'Totp'">Time-based OTP is enabled.</ng-container>
  <ng-container *ngSwitchCase="'Email'">Email OTP is enabled.</ng-container>
  <ng-container *ngSwitchDefault>MFA is disabled.</ng-container>
  <div>
    <button *ngIf="currentUser.mfaType && currentUser.mfaType != 'None'" mat-raised-button (click)="initDisable()">Disable</button>
    <ng-container *ngIf="!currentUser.mfaType || currentUser.mfaType == 'None'">
      <a *ngIf="settings?.enableTotpMfa" [routerLink]="['/mfa/totp']" mat-raised-button>Enable TOTP</a>
      <a *ngIf="settings?.enableEmailMfa" [routerLink]="['/mfa/email']" mat-raised-button>Enable Email MFA</a>
    </ng-container>
  </div>
</mat-card>
<mat-card *ngIf="disabling">
  Enter verification code
  <mat-form-field>
    <input [(ngModel)]="code" matInput type="password">
  </mat-form-field>
  <button (click)="disable()" mat-raised-button>Disable</button> <button mat-raised-button (click)="disabling = false">Cancel</button>
</mat-card>
